/**
 * Created by Arif Topcu in 2019
 */

import BetaSelector from './BetaSelector';

export default BetaSelector;
